import { WSService } from "../../../utils/WSService";
import { components, operations } from "./types";

const service = new WSService("/v2/resource-events");

export async function listResourceEvents(
  query?: operations["listResourceEvents"]["parameters"]["query"]
): Promise<components["schemas"]["IResourceEvent"][]> {
  const { data } = await service.get("", { params: query });
  return data;
}
